module.exports = __webpack_public_path__ + "static/media/SH1.3c32a527.png";